import * as React from 'react';
import styled from 'styled-components';
import { CurrencyInput as CoreCurrencyInput } from 'forms-core-components';
import { colors, fonts } from 'bench-style-constants';

const StyledCurrencyInput = styled(CoreCurrencyInput)`
  border: 0;
  border-radius: 0.25rem;
  min-width: 9ch;
  padding: 8px 16px;
  background: ${colors.shell};
  color: ${colors.charcoal};
  font-family: ${fonts.circular};
  font-size: 16px;
  font-weight: 300;
  line-height: 24px;
  transition: background 0.25s ease-in-out, color 0.25s ease-in-out;

  &:focus {
    outline: 0;
    box-shadow: inset 0 0 0 1px ${colors.stream};
  }

  &::placeholder {
    color: ${colors.dust};
  }
`;

const CurrencyInput = props => <StyledCurrencyInput {...props} />;

export default CurrencyInput;
